const routes = [];

routes[routes.length] = {
    path: '/',
    componentName: 'LandingPage',
    exact: true
};

routes[routes.length] = {
    path: '/ridb-access-agreement',
    componentName: 'AccessAgreementPage'
};

routes[routes.length] = {
    path: '/login',
    componentName: 'LoginPage'
};

routes[routes.length] = {
    path: '/search',
    componentName: 'SearchPage'
};

routes[routes.length] = {
    path: '/changelog',
    componentName: 'ChangelogPage'
};

routes[routes.length] = {
    path: '/docs',
    componentName: 'DocumentationPage'
};

routes[routes.length] = {
    path: '/download',
    componentName: 'DownloadPage'
};

routes[routes.length] = {
    path: '/profile',
    componentName: 'ProfilePage',
    requiresAuth: true
};

routes[routes.length] = {
    path: '/admin',
    componentName: 'UserAdminPage',
    requiresAuth: true,
    requiresAdminAccess: true
};

routes[routes.length] = {
  path: '/data-steward/docs',
  componentName: 'DocumentationPage'
};

routes[routes.length] = {
  path: '/data-steward/:assetType/search',
  componentName: 'StewardSearchPage',
  requiresAuth: true,
  requiresWriteAccess: true
};

routes[routes.length] = {
  path: '/data-steward/:assetType/new',
  componentName: 'StewardAssetNewPage',
  requiresAuth: true,
  requiresWriteAccess: true
};

routes[routes.length] = {
  path: '/data-steward/:assetType/:assetId/display',
  componentName: 'StewardAssetDisplayPage',
  requiresAuth: true,
  requiresWriteAccess: true
};

routes[routes.length] = {
  path: '/data-steward/:assetType/:assetId/edit',
  componentName: 'StewardAssetEditPage',
  requiresAuth: true,
  requiresWriteAccess: true
};

routes[routes.length] = {
  path: '/data-steward',
    componentName: 'StewardEntryPage',
    requiresAuth: true,
    requiresWriteAccess: true
};

export default routes;
